/* NSG Framework · nsg-places-with-soul */

(function () {
  const sections = document.querySelectorAll('.nsg-pws');

  if (!sections.length) return;

  sections.forEach((section) => {
    const cards = section.querySelectorAll('.nsg-pws__card');

    if (!cards.length) return;

    cards.forEach((card) => {
      card.addEventListener('focus', () => {
        card.classList.add('is-focused');
      });

      card.addEventListener('blur', () => {
        card.classList.remove('is-focused');
      });
    });
  });
})();